import { CurrentUser } from '../../current-user/currentUserTypes';

export const ANALYTICS_PROP = '__analytics__';
export const ANALYTICS_TYPE_PROP = '__type__';

export const SPOTIM_ANALYTICS = 'SPOTIM_ANALYTICS';

export function toAnalytics(payload: Record<string, any>) {
  return {
    [ANALYTICS_PROP]: payload
  };
}

const roleNameMapping: Partial<Record<keyof CurrentUser, string>> = {
  isAdmin: 'Admin',
  isSuperAdmin: 'Super Admin',
  isCommunityModerator: 'Community Moderator',
  isModerator: 'Moderator',
  isModerationViewer: 'Moderation Viewer',
  isJournalist: 'Journalist'
};

export function getUserRoles(user: CurrentUser) {
  const keys = Object.keys(roleNameMapping);
  const roles: Array<string> = [];

  keys.forEach(key => {
    if (user[key]) {
      roles.push(roleNameMapping[key]);
    }
  });

  return roles;
}

const MINUTE = 60 * 1000;

export function getTimestamp() {
  const now = new Date();
  const timezoneOffset = now.getTimezoneOffset() * MINUTE;

  // time without timezone offset
  const ms = now.getTime() + timezoneOffset;

  return { date: now.toISOString(), ms };
}
